import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const AnalyticsRunScoring = ({ allGames }) => {
  const { scoringDist, blowout, oneRun, shutouts } = useMemo(() => {
    if (!allGames?.length) return { scoringDist: [], blowout: 0, oneRun: 0, shutouts: 0 };
    const finished = allGames.filter(g => g.status?.abstractGameState === 'Final');
    const dist = {};
    let blowout = 0, oneRun = 0, shutouts = 0;

    finished.forEach(g => {
      const bosHome = g.teams?.home?.team?.id === 111;
      const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
      const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
      const key = String(bosScore);
      dist[key] = (dist[key] || 0) + 1;
      if (Math.abs(bosScore - oppScore) >= 5) blowout++;
      if (Math.abs(bosScore - oppScore) === 1) oneRun++;
      if (bosScore === 0) shutouts++;
    });

    const sorted = Object.entries(dist).sort((a, b) => Number(a[0]) - Number(b[0]));
    return { scoringDist: sorted, blowout, oneRun, shutouts };
  }, [allGames]);

  const distOption = {
    backgroundColor: 'transparent',
    grid: { top: 20, right: 20, bottom: 40, left: 44 },
    tooltip: { trigger: 'axis', backgroundColor: '#1e3a29', borderColor: '#658d71', textStyle: { color: '#d8ceb3', fontSize: 10 } },
    xAxis: { type: 'category', data: scoringDist.map(d => `${d[0]}R`), axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } } },
    yAxis: { type: 'value', minInterval: 1, axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } }, splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } } },
    series: [{
      name: 'Games',
      type: 'bar',
      data: scoringDist.map(d => ({
        value: d[1],
        itemStyle: { color: Number(d[0]) >= 5 ? 'rgba(169,201,177,0.85)' : Number(d[0]) === 0 ? 'rgba(196,51,62,0.75)' : 'rgba(216,206,179,0.6)', borderColor: Number(d[0]) >= 5 ? '#a9c9b1' : '#658d71', borderWidth: 1 }
      })),
    }],
  };

  const stats = [
    { label: 'Blowout Wins (5+)', value: blowout, color: 'text-[#a9c9b1]' },
    { label: '1-Run Games', value: oneRun, color: 'text-[#d8ceb3]' },
    { label: 'Shutouts (0 R)', value: shutouts, color: 'text-[#c4333e]' },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Runs Scored Distribution</span>
          <p className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest mt-0.5">How many times BOS scored N runs</p>
        </div>
        <div className="p-2"><ReactECharts option={distOption} style={{ height: '180px' }} /></div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {stats.map(s => (
          <div key={s.label} className="border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] flex flex-col items-center gap-1">
            <span className={`text-2xl font-black tabular-nums ${s.color}`}>{s.value}</span>
            <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest text-center">{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsRunScoring;